/* ───────────────────────────────────────────────────────────────────────────
   Weihnachts-Countdown
   Rechnet aus dem heutigen Datum pro Projekt-Bucket den spätesten
   Anschlagtermin aus. Keine Zahl steht im Copy - alles kommt aus
   #xmas-countdown-config (gerendert von sections/weihnachten-hero.liquid).

     letzter_anschlag = deadline - puffer_tage - ceil(stunden / stunden_pro_woche) * 7 Tage

   Status je Bucket:
     green  heute >= green_lead_days Tage vor dem letzten Anschlag
     amber  0 bis green_lead_days-1 Tage davor
     grey   danach (Bucket rutscht ans Ende, wird nicht ausgeblendet)

   Nach der Deadline wird der Countdown ausgeblendet; die Buckets bleiben
   als Zeitbudget-Navigation stehen. Ohne JS bleiben Datum und Status
   unsichtbar (CSS blendet sie erst mit .xmas-countdown-on ein).
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var DAY = 86400000;

  function parseISODate(value) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(String(value || '').trim());
    if (!m) return null;
    var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return isNaN(d.getTime()) ? null : d;
  }

  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function addDays(date, days) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
  }

  function num(value, fallback, min) {
    var n = Number(value);
    if (!isFinite(n) || n < min) return fallback;
    return n;
  }

  function all(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }

  function init() {
    var configEl = document.getElementById('xmas-countdown-config');
    if (!configEl) return;

    var cfg;
    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    if (!cfg || !cfg.buckets || !cfg.buckets.length) return;

    var deadline = parseISODate(cfg.deadline);
    if (!deadline) return;

    var bufferDays   = num(cfg.buffer_days, 3, 0);
    var hoursPerWeek = num(cfg.hours_per_week, 6, 0.5);
    var greenLead    = num(cfg.green_lead_days, 14, 0);
    var locale       = cfg.locale || 'de-DE';
    var labels       = cfg.labels || {};

    var today = startOfDay(new Date());
    var expired = today.getTime() > deadline.getTime();

    function formatDate(date) {
      try {
        return date.toLocaleDateString(locale, { day: 'numeric', month: 'long' });
      } catch (e) {
        return date.getDate() + '.' + (date.getMonth() + 1) + '.';
      }
    }

    cfg.buckets.forEach(function (bucket, index) {
      var key = bucket && bucket.key;
      if (!key) return;

      var hours = num(bucket.hours, 0, 0);
      var weeks = Math.ceil(hours / hoursPerWeek);
      var lastCastOn = addDays(deadline, -(bufferDays + weeks * 7));
      var daysLeft = Math.round((lastCastOn.getTime() - today.getTime()) / DAY);

      var state = 'grey';
      if (daysLeft >= greenLead) {
        state = 'green';
      } else if (daysLeft >= 0) {
        state = 'amber';
      }

      var dateText = labels.prefix
        ? labels.prefix + ' ' + formatDate(lastCastOn)
        : formatDate(lastCastOn);

      if (!expired) {
        all('[data-xmas-date="' + key + '"]').forEach(function (node) {
          node.textContent = dateText;
          node.setAttribute('datetime', [
            lastCastOn.getFullYear(),
            ('0' + (lastCastOn.getMonth() + 1)).slice(-2),
            ('0' + lastCastOn.getDate()).slice(-2)
          ].join('-'));
        });

        all('[data-xmas-status="' + key + '"]').forEach(function (node) {
          node.textContent = labels[state] || '';
          node.setAttribute('data-xmas-state', state);
        });
      }

      // Abgelaufene Buckets rutschen ans Ende der Chip-Reihe, bleiben aber sichtbar.
      all('[data-xmas-chip="' + key + '"]').forEach(function (node) {
        node.style.order = expired || state !== 'grey' ? String(index) : String(100 + index);
      });
    });

    document.documentElement.classList.add(expired ? 'xmas-countdown-off' : 'xmas-countdown-on');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: rendert Sektionen neu, dabei geht der geschriebene Termin
  // verloren. init() schreibt nur textContent und ist gefahrlos wiederholbar.
  document.addEventListener('shopify:section:load', init);
})();

/* ───────────────────────────────────────────────────────────────────────────
   Bucket-UI: Tabs (ab 900px) und „Mehr anzeigen" (unter 900px).
   Unter 900px werden die Tabs zu zwei untereinander liegenden Bloecken -
   das erledigt weihnachten.css, hier wird nur der Zustand gehalten.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // Der Theme-Editor ersetzt einzelne Sektionen im laufenden Dokument. Wir
  // binden deshalb pro Knoten genau einmal und markieren ihn.
  function claim(node) {
    if (node.getAttribute('data-xmas-ready') === 'true') return false;
    node.setAttribute('data-xmas-ready', 'true');
    return true;
  }

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-xmas-tab]'));
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      if (!claim(tab)) return;
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-xmas-tab');

        tabs.forEach(function (other) {
          var active = other === tab;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        Array.prototype.forEach.call(root.querySelectorAll('[data-xmas-panel]'), function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-xmas-panel') === target);
        });
      });
    });
  }

  function initShowMore(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-xmas-more]'), function (button) {
      if (!claim(button)) return;
      button.addEventListener('click', function () {
        var grid = document.getElementById(button.getAttribute('data-xmas-more'));
        if (!grid) return;
        grid.classList.add('is-expanded');
        button.hidden = true;
      });
    });
  }

  // Chip 4 („Nur noch mit Vorsprung") springt auf dieselbe Sektion wie Chip 3,
  // soll dort aber den Tab „Für Erwachsene" öffnen - sonst landet man auf den
  // Kinder-Kits und der Termin am Chip passt zu nichts, was man sieht.
  function initTabDeepLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-xmas-open-tab]'), function (link) {
      if (!claim(link)) return;
      link.addEventListener('click', function () {
        var want = link.getAttribute('data-xmas-open-tab') || '';
        if (!want) return;

        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;

        var target = document.getElementById(href.slice(1));
        if (!target) return;

        var tab = target.querySelector('[data-xmas-tab="' + want + '"]');
        if (tab) tab.click();
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-xmas-bucket]'), function (root) {
      initTabs(root);
      initShowMore(root);
    });
    initTabDeepLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
